import { ChangeEvent, useState } from "react";
import { useMutation } from "react-query";

import { subscribeToNewsletter } from "~/api/newsletter/subscribeToNewsletter";
import MainButton from "~/components/common/mainButton";
import { useBreakpoint } from "~/contexts/providers/breakpoint";
import { useLanguage } from "~/contexts/providers/language";
import englishTranslations from "~/localization/en";
import frenchTranslations from "~/localization/fr";

import styles from "./index.module.scss";

const AboutFooter = () => {
  const [email, setEmail] = useState("");

  const breakPoint = useBreakpoint();
  const isDesktop = breakPoint === "desktop" || breakPoint === "widescreen";
  const { language } = useLanguage();
  const aboutFooterTexts =
    language === "En"
      ? englishTranslations.aboutPage.footer
      : frenchTranslations.aboutPage.footer;

  const handleInputChange = (e: ChangeEvent<HTMLInputElement>) => {
    setEmail(e.target.value);
  };

  const {
    mutate: subscribeToNewsletterMutation,
    isLoading: subscribeToNewsletterLoading,
  } = useMutation(subscribeToNewsletter, {
    onSuccess: () => {
      setEmail("");
    },
  });

  const handleSubmitNewsletter = () => {
    subscribeToNewsletterMutation({ email });
  };

  return (
    <footer className={styles.aboutFooter}>
      {isDesktop && <div>{aboutFooterTexts.copyRights}</div>}
      <form
        className={styles.subscribeToNewsletter}
        onSubmit={(e) => e.preventDefault()}
      >
        <label>{isDesktop ? aboutFooterTexts.subscribe : "Newsletter"}</label>
        <input
          type="email"
          placeholder="Entrez votre email"
          size={16}
          onChange={handleInputChange}
        />
        <MainButton
          onClick={handleSubmitNewsletter}
          isLoading={subscribeToNewsletterLoading}
        >
          {aboutFooterTexts.apply}
        </MainButton>
      </form>
      <div>
        {!isDesktop && <div>©2022 Silencio Tous droits réservés.</div>}
        <div>
          Website design by <a href="https://www.hervethomas.com/">THS</a> —
          Development by <a href="https://poyesis.fr/">Poyesis</a>
        </div>
      </div>
    </footer>
  );
};

export default AboutFooter;
